import React, { Component } from "react";
import { connect } from "react-redux";
import union from "./img/union.svg";
import bacterium from "./img/bacterium.svg";
import { setTransformationValue } from "./store/actions";
import styles from "./style.module.scss";

class Predictions57 extends Component {
  // Handles image click events
  imageClicked = (tube) => {
    this.props.setTransformationValue({
      section: "predictions",
      transformation: this.props.component_type,
      value: tube,
    });
  };

  render() {
    const { heading, tubes, selected } = this.props;

    return (
      <div className={styles.sectionInteractive}>
        <h5 className={styles.sectionHeading} tabIndex={0}>
          {heading}
        </h5>

        <div className={styles.transformTubes}>
          <div className={styles.transformTubes__tube}>
            {tubes.map((tube) => (
              <div key={tube.id}>
                <img
                  draggable={false}
                  tabIndex={0}
                  onClick={() => this.imageClicked(tube.id)}
                  onKeyDown={(e) => {
                    if (e.which === 13 || e.which === 32) {
                      this.imageClicked(tube.id);
                    }
                  }}
                  src={
                    require(`./img/tube-${tube.id}${
                      tube.id === selected ? "-h" : ""
                    }-en.svg`).default
                  }
                  alt={tube.alt}
                />
              </div>
            ))}
          </div>

          <div className={styles.transformTubes__footer}>
            <TypeLabel image={union} label="Plasmid" />
            <TypeLabel image={bacterium} label="Bacterium" />
          </div>
        </div>
      </div>
    );
  }
}

// Component for displaying type label with image
const TypeLabel = ({ image, label }) => (
  <div className={styles.type}>
    <div className={`${styles.type__plasmid} ${styles.type__bacteria}`}>
      <img src={image} tabIndex={0} alt={label} />
      <label>{label}</label>
    </div>
  </div>
);

const mapStateToProps = (state, ownProps) => {
  return state.transformingBacteria["predictions"]
    ? {
        selected:
          state.transformingBacteria["predictions"][ownProps.component_type],
      }
    : {};
};

export const TransformingBacteriaPredictions = connect(mapStateToProps, {
  setTransformationValue,
})(Predictions57);
